import ModuleTable from './ModuleTable';

export default ModuleTable;
